__turbopack_context__.v({
  "helios-phone-field": "Xt6q6G_helios-phone-field",
  "helios-phone-field__country": "Xt6q6G_helios-phone-field__country",
  "helios-phone-field__input": "Xt6q6G_helios-phone-field__input",
});
